import { gql } from '@apollo/client';

export const GetResaleOffers = gql`
  query GetResaleOffers($customerId: String!) {
    webListingOffer {
      listOffers(input: { identifier: { customerId: $customerId } }) {
        offers {
          id
          address {
            uuid
          }
          details {
            contractSignatureId
            state
          }
        }
      }
    }
  }
`;
